export function useDebounceFn<T extends (...args: any[]) => any>(fn: T, delay = 1000) {
  let timeout: NodeJS.Timeout | undefined

  return ((...args: Parameters<T>) => {
    if (timeout) {
      clearTimeout(timeout)
    }

    return new Promise<ReturnType<T>>((resolve) => {
      timeout = setTimeout(() => {
        resolve(fn(...args))
      }, delay)
    })
  }) as T
}
